"use client";
var dt = Object.defineProperty;
var ft = (n, e, t) => e in n ? dt(n, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : n[e] = t;
var Ge = (n, e, t) => ft(n, typeof e != "symbol" ? e + "" : e, t);
import { j as Z } from "./jsx-runtime-CJ-St4mQ.mjs";
import * as r from "react";
import { t as mt } from "./tv.config-BuYIgndg.mjs";
import { c as Le } from "./createLucideIcon-BjO0sRuo.mjs";
import { u as pt } from "./useControlled-B2rPEZCb.mjs";
import { u as ee } from "./useEventCallback-CjuAhyNz.mjs";
import { T as bt, u as We } from "./useTimeout-BRUciAq6.mjs";
import { a as ht, u as le } from "./useRenderElement-B8V3_e8R.mjs";
import { u as gt } from "./useOnMount-JHtE6teb.mjs";
import { u as oe } from "./useIsoLayoutEffect-DpJo20by.mjs";
import { u as Pe } from "./useLatestRef-BZ_hd_SE.mjs";
import { u as yt } from "./useForcedRerendering-D5LqFHht.mjs";
import { o as ve } from "./owner-DpSCkBia.mjs";
import { d as xt, c as Ye } from "./detectBrowser-CpuomNQW.mjs";
import { u as qe, f as Rt } from "./FieldRootContext-Cj7-dNhd.mjs";
import { u as Nt } from "./useBaseUiId-a-UPSsPQ.mjs";
import { c as Et } from "./clamp-6qWnNXLC.mjs";
import { k as Ae } from "./floating-ui.utils.dom-DmuU7Umk.mjs";
import * as De from "react-dom";
import { u as Xe } from "./useButton-CQeWQM5o.mjs";
import { u as St, a as Ct } from "./useFieldControlValidation-B3M7EPH2.mjs";
import { u as Vt } from "./FormContext-CYX6HnEQ.mjs";
import { s as vt } from "./event-CXjJudzK.mjs";
/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const It = [["path", { d: "M5 12h14", key: "1ays0h" }]], At = Le("minus", It);
/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const wt = [
  ["path", { d: "m18 8 4 4-4 4", key: "1ak13k" }],
  ["path", { d: "M2 12h20", key: "9i4pu4" }],
  ["path", { d: "m6 8-4 4 4 4", key: "15zrgr" }]
], Ft = Le("move-horizontal", wt);
/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Tt = [
  ["path", { d: "M5 12h14", key: "1ays0h" }],
  ["path", { d: "M12 5v14", key: "s699le" }]
], Pt = Le("plus", Tt), Ke = 0;
class _e extends bt {
  constructor() {
    super(...arguments);
    Ge(this, "clear", () => {
      this.currentId !== Ke && (clearInterval(this.currentId), this.currentId = Ke);
    });
  }
  static create() {
    return new _e();
  }
  /**
   * Executes `fn` at `delay` interval, clearing any previously scheduled call.
   */
  start(t, a) {
    this.clear(), this.currentId = setInterval(() => {
      a();
    }, t);
  }
}
function Dt() {
  const n = ht(_e.create).current;
  return gt(n.disposeEffect), n;
}
const Oe = /* @__PURE__ */ r.createContext(void 0);
process.env.NODE_ENV !== "production" && (Oe.displayName = "NumberFieldRootContext");
function ce() {
  const n = r.useContext(Oe);
  if (n === void 0)
    throw new Error("Base UI: NumberFieldRootContext is missing. NumberField parts must be placed within <NumberField.Root>.");
  return n;
}
const de = {
  inputValue: () => null,
  value: () => null
}, ze = /* @__PURE__ */ new Map();
function Ie(n, e) {
  const t = JSON.stringify({
    locale: n,
    options: e
  }), a = ze.get(t);
  if (a)
    return a;
  const o = new Intl.NumberFormat(n, e);
  return ze.set(t, o), o;
}
function be(n, e, t) {
  return n == null ? "" : Ie(e, t).format(n);
}
function Je(n, e, t) {
  return be(n, e, {
    ...t,
    maximumFractionDigits: 20
  });
}
const Ze = ["零", "一", "二", "三", "四", "五", "六", "七", "八", "九"], Qe = ["٠", "١", "٢", "٣", "٤", "٥", "٦", "٧", "٨", "٩"], et = ["%", "٪"], Me = new RegExp(`[${Qe.join("")}]`, "g"), ke = new RegExp(`[${Ze.join("")}]`, "g"), Mt = new RegExp(`[${et.join("")}]`);
function He(n, e) {
  const t = Ie(n, e).formatToParts(11111.1), a = {};
  return t.forEach((o) => {
    a[o.type] = o.value;
  }), Ie(n).formatToParts(0.1).forEach((o) => {
    o.type === "decimal" && (a[o.type] = o.value);
  }), a;
}
function ae(n, e, t) {
  let a = e;
  a === void 0 && (Me.test(n) ? a = "ar" : ke.test(n) && (a = "zh"));
  const {
    group: o,
    decimal: f,
    currency: b,
    unit: m
  } = He(a, t);
  let g = null;
  o && (g = new RegExp("\\p{Zs}", "u").test(o) ? new RegExp("\\p{Zs}", "gu") : new RegExp(`\\${o}`, "g"));
  const i = [{
    regex: o ? g : null,
    replacement: ""
  }, {
    regex: f ? new RegExp(`\\${f}`, "g") : null,
    replacement: "."
  }, {
    regex: b ? new RegExp(`\\${b}`, "g") : null,
    replacement: ""
  }, {
    regex: m ? new RegExp(`\\${m}`, "g") : null,
    replacement: ""
  }, {
    regex: Me,
    replacement: (p) => Qe.indexOf(p).toString()
  }, {
    regex: ke,
    replacement: (p) => Ze.indexOf(p).toString()
  }].reduce((p, {
    regex: v,
    replacement: M
  }) => v ? p.replace(v, M) : p, n);
  let d = parseFloat(i);
  const x = t == null ? void 0 : t.style, D = x === "unit" && (t == null ? void 0 : t.unit) === "percent", c = Mt.test(n) || x === "percent";
  return !D && c && (d /= 100), Number.isNaN(d) ? null : d;
}
const kt = 60, Lt = 400, _t = 50, Ot = 3, Ht = 8, Ce = 1;
function Ve(n, e = {}) {
  return parseFloat(Ie("en-US", {
    maximumFractionDigits: e.maximumFractionDigits,
    minimumFractionDigits: e.minimumFractionDigits,
    useGrouping: !1
  }).format(n));
}
function jt(n, {
  step: e,
  minWithDefault: t,
  maxWithDefault: a,
  minWithZeroDefault: o,
  format: f,
  snapOnStep: b,
  small: m
}) {
  if (n === null)
    return n;
  const g = Et(n, t, a);
  if (e != null && b) {
    if (m) {
      const i = (g - o) / e, d = Math.round(i), x = o + d * e;
      return Ve(x, f);
    }
    const y = t !== Number.MIN_SAFE_INTEGER ? t : o;
    if (e > 0) {
      const i = g - e, d = Math.floor((i - y) / e);
      return Ve(y + d * e + e, f);
    }
    if (e < 0) {
      const i = Math.abs(e), d = g - e, x = Math.ceil((d - y) / i);
      return Ve(y + x * i + e, f);
    }
  }
  return Ve(g, f);
}
const tt = /* @__PURE__ */ r.forwardRef(function(e, t) {
  const {
    id: a,
    min: o,
    max: f,
    smallStep: b = 0.1,
    step: m = 1,
    largeStep: g = 10,
    required: y = !1,
    disabled: i = !1,
    readOnly: d = !1,
    name: x,
    defaultValue: D,
    value: c,
    onValueChange: p,
    allowWheelScrub: v = !1,
    snapOnStep: M = !1,
    format: h,
    locale: E,
    render: F,
    className: z,
    inputRef: O,
    ...A
  } = e, {
    setControlId: G,
    setDirty: S,
    validityData: T,
    setValidityData: W,
    disabled: P,
    setFilled: k,
    invalid: u,
    name: H,
    state: $
  } = qe(), L = P || i, l = H ?? x, [I, j] = r.useState(!1), C = o ?? Number.MIN_SAFE_INTEGER, V = f ?? Number.MAX_SAFE_INTEGER, X = o ?? 0, B = h == null ? void 0 : h.style, Y = r.useRef(null), s = Nt(a);
  oe(() => (G(s), () => {
    G(void 0);
  }), [s, G]);
  const [R, K] = pt({
    controlled: c,
    default: D,
    name: "NumberField",
    state: "value"
  }), N = R ?? null, te = Pe(N);
  oe(() => {
    k(N !== null);
  }, [k, N]);
  const ne = yt(), ue = Pe(h), re = ee(p), ie = We(), he = Dt(), ge = We(), ye = r.useRef(!1), xe = r.useRef(0), fe = r.useRef(!0), Re = r.useRef(() => {
  });
  oe(() => {
    T.initialValue === null && N !== T.initialValue && W((U) => ({
      ...U,
      initialValue: N
    }));
  }, [W, T.initialValue, N]);
  const [se, Q] = r.useState(() => c !== void 0 ? $e(N, E, h) : be(N, E, h)), [Ne, we] = r.useState("numeric"), Be = ee(() => {
    const {
      decimal: U,
      group: w,
      currency: q
    } = He(E, h), _ = /* @__PURE__ */ new Set([".", ",", U, w]);
    return B === "percent" && et.forEach((J) => _.add(J)), B === "currency" && q && _.add(q), C < 0 && _.add("-"), _;
  }), me = ee((U) => U != null && U.altKey ? b : U != null && U.shiftKey ? g : m), Fe = ee((U, w, q) => {
    const _ = w, J = jt(U, {
      step: q ? me(_) * q : void 0,
      format: ue.current,
      minWithDefault: C,
      maxWithDefault: V,
      minWithZeroDefault: X,
      snapOnStep: M,
      small: (_ == null ? void 0 : _.altKey) ?? !1
    });
    re == null || re(J, w && "nativeEvent" in w ? w.nativeEvent : w), K(J), S(J !== T.initialValue), fe.current && Q(be(J, E, h)), ne();
  }), Ee = ee((U, w, q, _) => {
    const J = q ?? te.current, Se = typeof J == "number" ? J + U * w : Math.max(0, o ?? 0);
    Fe(Se, _, w);
  }), pe = ee(() => {
    ge.clear(), ie.clear(), he.clear(), Re.current(), xe.current = 0;
  }), Ue = ee((U, w) => {
    if (pe(), !Y.current)
      return;
    const q = Ae(Y.current);
    function _(Se) {
      Se.preventDefault();
    }
    q.addEventListener("contextmenu", _), Re.current = () => {
      q.removeEventListener("contextmenu", _);
    }, q.addEventListener("pointerup", () => {
      ye.current = !1, pe();
    }, {
      once: !0
    });
    function J() {
      const Se = me(w) ?? Ce;
      Ee(Se, U ? 1 : -1, void 0, w);
    }
    J(), ie.start(Lt, () => {
      he.start(kt, J);
    });
  });
  oe(function() {
    if (!fe.current)
      return;
    const w = c !== void 0 ? $e(N, E, h) : be(N, E, h);
    w !== se && Q(w);
  }), oe(function() {
    if (!xt)
      return;
    let w = "text";
    C >= 0 && (w = "decimal"), we(w);
  }, [C, B]), r.useEffect(() => () => pe(), [pe]), r.useEffect(function() {
    const w = Y.current;
    if (L || d || !v || !w)
      return;
    function q(_) {
      if (
        // Allow pinch-zooming.
        _.ctrlKey || ve(Y.current).activeElement !== Y.current
      )
        return;
      _.preventDefault();
      const J = me(_) ?? Ce;
      Ee(J, _.deltaY > 0 ? -1 : 1, void 0, _);
    }
    return w.addEventListener("wheel", q), () => {
      w.removeEventListener("wheel", q);
    };
  }, [v, Ee, L, d, g, m, me]);
  const Te = r.useMemo(() => ({
    ...$,
    disabled: L,
    readOnly: d,
    required: y,
    value: N,
    inputValue: se,
    scrubbing: I
  }), [$, L, d, y, N, se, I]), ct = r.useMemo(() => ({
    inputRef: Y,
    inputValue: se,
    value: N,
    startAutoChange: Ue,
    stopAutoChange: pe,
    minWithDefault: C,
    maxWithDefault: V,
    disabled: L,
    readOnly: d,
    id: s,
    setValue: Fe,
    incrementValue: Ee,
    getStepAmount: me,
    allowInputSyncRef: fe,
    formatOptionsRef: ue,
    valueRef: te,
    isPressedRef: ye,
    intentionalTouchCheckTimeout: ge,
    movesAfterTouchRef: xe,
    name: l,
    required: y,
    invalid: u,
    inputMode: Ne,
    getAllowedNonNumericKeys: Be,
    min: o,
    max: f,
    setInputValue: Q,
    locale: E,
    isScrubbing: I,
    setIsScrubbing: j,
    state: Te
  }), [Y, se, N, Ue, pe, C, V, L, d, s, Fe, Ee, me, fe, ue, te, ye, ge, xe, l, y, u, Ne, Be, o, f, Q, E, I, Te]), lt = le("div", e, {
    ref: t,
    state: Te,
    props: A,
    customStyleHookMapping: de
  });
  return /* @__PURE__ */ Z.jsxs(Oe.Provider, {
    value: ct,
    children: [lt, l && /* @__PURE__ */ Z.jsx("input", {
      type: "hidden",
      name: l,
      ref: O,
      value: N ?? "",
      disabled: L,
      required: y
    })]
  });
});
process.env.NODE_ENV !== "production" && (tt.displayName = "NumberFieldRoot");
function $e(n, e, t) {
  return (t == null ? void 0 : t.maximumFractionDigits) != null || (t == null ? void 0 : t.minimumFractionDigits) != null ? be(n, e, t) : Je(n, e, t);
}
const nt = /* @__PURE__ */ r.forwardRef(function(e, t) {
  const {
    render: a,
    className: o,
    ...f
  } = e, {
    state: b
  } = ce();
  return le("div", e, {
    ref: t,
    state: b,
    props: [{
      role: "group"
    }, f],
    customStyleHookMapping: de
  });
});
process.env.NODE_ENV !== "production" && (nt.displayName = "NumberFieldGroup");
function rt(n) {
  const {
    allowInputSyncRef: e,
    disabled: t,
    formatOptionsRef: a,
    getStepAmount: o,
    id: f,
    incrementValue: b,
    inputRef: m,
    inputValue: g,
    intentionalTouchCheckTimeout: y,
    isIncrement: i,
    isPressedRef: d,
    locale: x,
    maxWithDefault: D,
    minWithDefault: c,
    movesAfterTouchRef: p,
    readOnly: v,
    setValue: M,
    startAutoChange: h,
    stopAutoChange: E,
    value: F,
    valueRef: z
  } = n, O = r.useRef({
    x: 0,
    y: 0
  }), A = r.useRef(!1), G = r.useRef(!1), S = r.useRef(""), T = F != null && F <= c, W = F != null && F >= D, P = ee((u) => {
    e.current = !0;
    const H = ae(g, x, a.current);
    H !== null && (z.current = H, M(H, u));
  }), k = r.useMemo(() => ({
    disabled: t || (i ? W : T),
    "aria-readonly": v || void 0,
    "aria-label": i ? "Increase" : "Decrease",
    "aria-controls": f,
    // Keyboard users shouldn't have access to the buttons, since they can use the input element
    // to change the value. On the other hand, `aria-hidden` is not applied because touch screen
    // readers should be able to use the buttons.
    tabIndex: -1,
    style: {
      WebkitUserSelect: "none",
      userSelect: "none"
    },
    onTouchStart() {
      A.current = !0;
    },
    onTouchEnd() {
      A.current = !1;
    },
    onClick(u) {
      const H = t || v || (i ? W : T);
      if (u.defaultPrevented || H || // If it's not a keyboard/virtual click, ignore.
      (S.current === "touch" ? G.current : u.detail !== 0))
        return;
      P(u.nativeEvent);
      const $ = o(u) ?? Ce;
      b($, i ? 1 : -1, void 0, u.nativeEvent);
    },
    onPointerDown(u) {
      var L;
      const H = !u.button || u.button === 0, $ = t || (i ? W : T);
      u.defaultPrevented || v || !H || $ || (S.current = u.pointerType, G.current = !1, d.current = !0, O.current = {
        x: u.clientX,
        y: u.clientY
      }, P(u.nativeEvent), u.pointerType !== "touch" ? (u.preventDefault(), (L = m.current) == null || L.focus(), h(i, u)) : y.start(_t, () => {
        const l = p.current;
        p.current = 0, l != null && l < Ot ? (G.current = !0, h(i, u)) : E();
      }));
    },
    onPointerMove(u) {
      if (t || v || (i ? W : T) || u.pointerType !== "touch" || !d.current)
        return;
      p.current != null && (p.current += 1);
      const {
        x: $,
        y: L
      } = O.current, l = $ - u.clientX, I = L - u.clientY;
      l ** 2 + I ** 2 > Ht ** 2 && E();
    },
    onMouseEnter(u) {
      const H = t || v || (i ? W : T);
      u.defaultPrevented || H || !d.current || A.current || h(i, u);
    },
    onMouseLeave() {
      A.current || E();
    },
    onMouseUp() {
      A.current || E();
    }
  }), [P, t, o, f, b, m, i, y, W, T, d, p, v, h, E]);
  return r.useMemo(() => ({
    props: k
  }), [k]);
}
const st = /* @__PURE__ */ r.forwardRef(function(e, t) {
  const {
    render: a,
    className: o,
    disabled: f = !1,
    nativeButton: b = !0,
    ...m
  } = e, {
    allowInputSyncRef: g,
    disabled: y,
    formatOptionsRef: i,
    getStepAmount: d,
    id: x,
    incrementValue: D,
    inputRef: c,
    inputValue: p,
    intentionalTouchCheckTimeout: v,
    isPressedRef: M,
    locale: h,
    maxWithDefault: E,
    minWithDefault: F,
    movesAfterTouchRef: z,
    readOnly: O,
    setValue: A,
    startAutoChange: G,
    state: S,
    stopAutoChange: T,
    value: W,
    valueRef: P
  } = ce(), k = f || y, {
    props: u
  } = rt({
    isIncrement: !0,
    inputRef: c,
    startAutoChange: G,
    stopAutoChange: T,
    minWithDefault: F,
    maxWithDefault: E,
    value: W,
    inputValue: p,
    disabled: k,
    readOnly: O,
    id: x,
    setValue: A,
    getStepAmount: d,
    incrementValue: D,
    allowInputSyncRef: g,
    formatOptionsRef: i,
    valueRef: P,
    isPressedRef: M,
    intentionalTouchCheckTimeout: v,
    movesAfterTouchRef: z,
    locale: h
  }), {
    getButtonProps: H,
    buttonRef: $
  } = Xe({
    disabled: k,
    native: b
  }), L = r.useMemo(() => ({
    ...S,
    disabled: k
  }), [S, k]);
  return le("button", e, {
    ref: [t, $],
    state: L,
    props: [u, m, H],
    customStyleHookMapping: de
  });
});
process.env.NODE_ENV !== "production" && (st.displayName = "NumberFieldIncrement");
const ot = /* @__PURE__ */ r.forwardRef(function(e, t) {
  const {
    render: a,
    className: o,
    disabled: f = !1,
    nativeButton: b = !0,
    ...m
  } = e, {
    allowInputSyncRef: g,
    disabled: y,
    formatOptionsRef: i,
    getStepAmount: d,
    id: x,
    incrementValue: D,
    inputRef: c,
    inputValue: p,
    intentionalTouchCheckTimeout: v,
    isPressedRef: M,
    maxWithDefault: h,
    minWithDefault: E,
    movesAfterTouchRef: F,
    readOnly: z,
    setValue: O,
    startAutoChange: A,
    state: G,
    stopAutoChange: S,
    value: T,
    valueRef: W,
    locale: P
  } = ce(), k = f || y, {
    props: u
  } = rt({
    isIncrement: !1,
    inputRef: c,
    startAutoChange: A,
    stopAutoChange: S,
    minWithDefault: E,
    maxWithDefault: h,
    value: T,
    inputValue: p,
    disabled: k,
    readOnly: z,
    id: x,
    setValue: O,
    getStepAmount: d,
    incrementValue: D,
    allowInputSyncRef: g,
    formatOptionsRef: i,
    valueRef: W,
    isPressedRef: M,
    intentionalTouchCheckTimeout: v,
    movesAfterTouchRef: F,
    locale: P
  }), {
    getButtonProps: H,
    buttonRef: $
  } = Xe({
    disabled: k,
    native: b
  }), L = r.useMemo(() => ({
    ...G,
    disabled: k
  }), [G, k]);
  return le("button", e, {
    ref: [t, $],
    state: L,
    props: [u, m, H],
    customStyleHookMapping: de
  });
});
process.env.NODE_ENV !== "production" && (ot.displayName = "NumberFieldDecrement");
const Bt = {
  ...Rt,
  ...de
}, Ut = /* @__PURE__ */ new Set(["Backspace", "Delete", "ArrowLeft", "ArrowRight", "Tab", "Enter", "Escape"]), ut = /* @__PURE__ */ r.forwardRef(function(e, t) {
  const {
    render: a,
    className: o,
    ...f
  } = e, {
    allowInputSyncRef: b,
    disabled: m,
    formatOptionsRef: g,
    getAllowedNonNumericKeys: y,
    getStepAmount: i,
    id: d,
    incrementValue: x,
    inputMode: D,
    inputValue: c,
    max: p,
    min: v,
    name: M,
    readOnly: h,
    required: E,
    setValue: F,
    state: z,
    setInputValue: O,
    locale: A,
    inputRef: G,
    value: S
  } = ce(), {
    clearErrors: T
  } = Vt(), {
    labelId: W,
    validationMode: P,
    setTouched: k,
    setFocused: u,
    invalid: H
  } = qe(), {
    getInputValidationProps: $,
    getValidationProps: L,
    commitValidation: l,
    inputRef: I
  } = St(), j = r.useRef(!1), C = r.useRef(!1);
  Ct({
    id: d,
    commitValidation: l,
    value: S,
    controlRef: G,
    name: M,
    getValue: () => S ?? null
  });
  const V = r.useRef(S), X = r.useRef(c);
  return oe(() => {
    V.current === S && X.current === c || (T(M), P === "onChange" && l(S));
  }, [S, c, M, T, P, l]), oe(() => {
    if (!(V.current === S || P === "onChange")) {
      if (C.current) {
        C.current = !1;
        return;
      }
      l(S, !0);
    }
  }, [l, P, S]), oe(() => {
    V.current = S, X.current = c;
  }, [S, c]), le("input", e, {
    ref: [t, G, I],
    state: z,
    props: [{
      id: d,
      required: E,
      disabled: m,
      readOnly: h,
      inputMode: D,
      value: c,
      type: "text",
      autoComplete: "off",
      autoCorrect: "off",
      spellCheck: "false",
      "aria-roledescription": "Number field",
      "aria-invalid": H || void 0,
      "aria-labelledby": W,
      // If the server's locale does not match the client's locale, the formatting may not match,
      // causing a hydration mismatch.
      suppressHydrationWarning: !0,
      onFocus(s) {
        if (s.defaultPrevented || h || m || j.current)
          return;
        j.current = !0, u(!0);
        const R = s.currentTarget, K = R.value.length;
        R.setSelectionRange(K, K);
      },
      onBlur(s) {
        if (s.defaultPrevented || h || m)
          return;
        if (k(!0), u(!1), b.current = !0, c.trim() === "") {
          F(null), P === "onBlur" && l(null);
          return;
        }
        const R = g.current, K = ae(c, A, R), N = be(K, A, R), te = Je(K, A, R), ne = ae(N, A, R), ue = ae(te, A, R);
        if (K === null)
          return;
        C.current = !0, P === "onBlur" && l(ne), (R == null ? void 0 : R.maximumFractionDigits) != null || (R == null ? void 0 : R.minimumFractionDigits) != null ? (S !== ne && F(ne, s.nativeEvent), c !== N && O(N)) : S !== ue ? F(ne, s.nativeEvent) : !(K === S && c === te) && c !== N && O(N);
      },
      onChange(s) {
        if (s.nativeEvent.defaultPrevented)
          return;
        b.current = !1;
        const R = s.target.value;
        if (R.trim() === "") {
          O(R), F(null, s.nativeEvent);
          return;
        }
        if (s.isTrusted) {
          O(R);
          return;
        }
        const K = ae(R, A, g.current);
        K !== null && (O(R), F(K, s.nativeEvent));
      },
      onKeyDown(s) {
        if (s.defaultPrevented || h || m)
          return;
        const R = s.nativeEvent;
        b.current = !0;
        const K = y();
        let N = K.has(s.key);
        const {
          decimal: te,
          currency: ne,
          percentSign: ue
        } = He([], g.current), re = s.currentTarget.selectionStart, ie = s.currentTarget.selectionEnd, he = re === 0 && ie === c.length;
        if (s.key === "-" && K.has("-")) {
          const Q = re === 0 && ie === 1 && c[0] === "-";
          N = !c.includes("-") || he || Q;
        }
        [te, ne, ue].forEach((Q) => {
          if (s.key === Q) {
            const Ne = c.indexOf(Q), we = re === Ne && ie === Ne + 1;
            N = !c.includes(Q) || he || we;
          }
        });
        const ge = /^[0-9]$/.test(s.key), ye = Me.test(s.key), xe = ke.test(s.key), fe = Ut.has(s.key);
        if (
          // Allow composition events (e.g., pinyin)
          // event.nativeEvent.isComposing does not work in Safari:
          // https://bugs.webkit.org/show_bug.cgi?id=165004
          s.which === 229 || s.altKey || s.ctrlKey || s.metaKey || N || ge || ye || xe || fe
        )
          return;
        const Re = ae(c, A, g.current), se = i(s) ?? Ce;
        vt(s), s.key === "ArrowUp" ? x(se, 1, Re, R) : s.key === "ArrowDown" ? x(se, -1, Re, R) : s.key === "Home" && v != null ? F(v, R) : s.key === "End" && p != null && F(p, R);
      },
      onPaste(s) {
        if (s.defaultPrevented || h || m)
          return;
        s.preventDefault();
        const K = (s.clipboardData || window.Clipboard).getData("text/plain"), N = ae(K, A, g.current);
        N !== null && (b.current = !1, F(N, s.nativeEvent), O(K));
      }
    }, $(), L(), f],
    customStyleHookMapping: Bt
  });
});
process.env.NODE_ENV !== "production" && (ut.displayName = "NumberFieldInput");
const je = /* @__PURE__ */ r.createContext(void 0);
process.env.NODE_ENV !== "production" && (je.displayName = "NumberFieldScrubAreaContext");
function Gt() {
  const n = r.useContext(je);
  if (n === void 0)
    throw new Error("Base UI: NumberFieldScrubAreaContext is missing. NumberFieldScrubArea parts must be placed within <NumberField.ScrubArea>.");
  return n;
}
function Wt(n, e) {
  const t = Ae(e), a = e.getBoundingClientRect();
  if (a && n != null)
    return {
      x: a.left - n / 2,
      y: a.top - n / 2,
      width: a.right + n / 2,
      height: a.bottom + n / 2
    };
  const o = t.visualViewport;
  return o ? {
    x: o.offsetLeft,
    y: o.offsetTop,
    width: o.offsetLeft + o.width,
    height: o.offsetTop + o.height
  } : {
    x: 0,
    y: 0,
    width: t.document.documentElement.clientWidth,
    height: t.document.documentElement.clientHeight
  };
}
function Kt(n, e) {
  const t = Ae(n).visualViewport;
  if (!t)
    return () => {
    };
  function a() {
    t && (e.current = t.scale);
  }
  return a(), t.addEventListener("resize", a), () => {
    t.removeEventListener("resize", a);
  };
}
const it = /* @__PURE__ */ r.forwardRef(function(e, t) {
  const {
    render: a,
    className: o,
    direction: f = "horizontal",
    pixelSensitivity: b = 2,
    teleportDistance: m,
    ...g
  } = e, {
    state: y
  } = ce(), {
    isScrubbing: i,
    setIsScrubbing: d,
    disabled: x,
    readOnly: D,
    value: c,
    inputRef: p,
    incrementValue: v,
    getStepAmount: M
  } = ce(), h = Pe(c), E = r.useRef(null), F = r.useRef(!1), z = r.useRef(null), O = r.useRef({
    x: 0,
    y: 0
  }), A = r.useRef(1), [G, S] = r.useState(!1), [T, W] = r.useState(!1);
  r.useEffect(() => {
    if (!(!i || !z.current))
      return Kt(z.current, A);
  }, [i]);
  const P = ee((l, I) => {
    z.current && (z.current.style.transform = `translate3d(${l}px,${I}px,0) scale(${1 / A.current})`);
  }), k = r.useCallback(({
    movementX: l,
    movementY: I
  }) => {
    const j = z.current, C = E.current;
    if (!j || !C)
      return;
    const V = Wt(m, C), X = O.current, B = {
      x: Math.round(X.x + l),
      y: Math.round(X.y + I)
    }, Y = j.offsetWidth, s = j.offsetHeight;
    B.x + Y / 2 < V.x ? B.x = V.width - Y / 2 : B.x + Y / 2 > V.width && (B.x = V.x - Y / 2), B.y + s / 2 < V.y ? B.y = V.height - s / 2 : B.y + s / 2 > V.height && (B.y = V.y - s / 2), O.current = B, P(B.x, B.y);
  }, [m, P]), u = r.useCallback((l, {
    clientX: I,
    clientY: j
  }) => {
    De.flushSync(() => {
      d(l);
    });
    const C = z.current;
    if (!C || !l)
      return;
    const V = {
      x: I - C.offsetWidth / 2,
      y: j - C.offsetHeight / 2
    };
    O.current = V, P(V.x, V.y);
  }, [d, P]);
  r.useEffect(function() {
    if (!p.current || x || D)
      return;
    let I = 0;
    function j(X) {
      try {
        ve(E.current).exitPointerLock();
      } catch {
      } finally {
        F.current = !1, u(!1, X);
      }
    }
    function C(X) {
      if (!F.current)
        return;
      X.preventDefault(), k(X);
      const {
        movementX: B,
        movementY: Y
      } = X;
      if (I += f === "vertical" ? Y : B, Math.abs(I) >= b) {
        I = 0;
        const s = f === "vertical" ? -Y : B;
        v(s * (M(X) ?? Ce), 1);
      }
    }
    const V = Ae(p.current);
    return V.addEventListener("pointerup", j, !0), V.addEventListener("pointermove", C, !0), () => {
      V.removeEventListener("pointerup", j, !0), V.removeEventListener("pointermove", C, !0);
    };
  }, [x, D, v, h, M, p, u, k, f, b]), r.useEffect(function() {
    const I = E.current;
    if (!I || x || D)
      return;
    function j(C) {
      C.touches.length === 1 && C.preventDefault();
    }
    return I.addEventListener("touchstart", j), () => {
      I.removeEventListener("touchstart", j);
    };
  }, [x, D]);
  const $ = le("span", e, {
    ref: [t, E],
    state: y,
    props: [{
      role: "presentation",
      style: {
        touchAction: "none",
        WebkitUserSelect: "none",
        userSelect: "none"
      },
      async onPointerDown(l) {
        var C;
        const I = !l.button || l.button === 0;
        if (l.defaultPrevented || D || !I || x)
          return;
        const j = l.pointerType === "touch";
        if (S(j), l.pointerType === "mouse" && (l.preventDefault(), (C = p.current) == null || C.focus()), F.current = !0, u(!0, l.nativeEvent), !j && !Ye)
          try {
            await ve(E.current).body.requestPointerLock(), W(!1);
          } catch {
            W(!0);
          } finally {
            De.flushSync(() => {
              u(!0, l.nativeEvent);
            });
          }
      }
    }, g],
    customStyleHookMapping: de
  }), L = r.useMemo(() => ({
    isScrubbing: i,
    isTouchInput: G,
    isPointerLockDenied: T,
    scrubAreaCursorRef: z,
    scrubAreaRef: E,
    direction: f,
    pixelSensitivity: b,
    teleportDistance: m
  }), [i, G, T, f, b, m]);
  return /* @__PURE__ */ Z.jsx(je.Provider, {
    value: L,
    children: $
  });
});
process.env.NODE_ENV !== "production" && (it.displayName = "NumberFieldScrubArea");
const at = /* @__PURE__ */ r.forwardRef(function(e, t) {
  const {
    render: a,
    className: o,
    ...f
  } = e, {
    state: b
  } = ce(), {
    isScrubbing: m,
    isTouchInput: g,
    isPointerLockDenied: y,
    scrubAreaCursorRef: i
  } = Gt(), [d, x] = r.useState(null), c = le("span", e, {
    enabled: m && !Ye && !g && !y,
    ref: [t, i, x],
    state: b,
    props: [{
      role: "presentation",
      style: {
        position: "fixed",
        top: 0,
        left: 0,
        pointerEvents: "none"
      }
    }, f],
    customStyleHookMapping: de
  });
  return c && /* @__PURE__ */ De.createPortal(c, ve(d).body);
});
process.env.NODE_ENV !== "production" && (at.displayName = "NumberFieldScrubAreaCursor");
const zt = mt({
  slots: {
    root: ["flex"],
    scrubArea: ["cursor-ew-resize"],
    scrubAreaCursor: ["drop-shadow-[0_1px_1px_#0008] filter"],
    label: ["cursor-ew-resize text-sm font-medium text-gray-900"],
    fieldGroup: ["flex"],
    decrement: [
      "flex size-10 items-center justify-center rounded-tl-xl rounded-bl-xl border border-gray-300 bg-gray-50 bg-clip-padding text-gray-900 select-none hover:bg-gray-100 active:bg-gray-100"
    ],
    input: [
      "h-10 w-20 border-t border-b border-gray-300 text-center text-base text-gray-900 tabular-nums focus:z-10 focus:outline focus:outline-0 focus:-outline-offset-1 focus:outline-blue-800"
    ],
    increment: [
      "flex size-10 items-center justify-center rounded-tr-xl rounded-br-xl border border-gray-300 bg-gray-50 bg-clip-padding text-gray-900 select-none hover:bg-gray-100 active:bg-gray-100"
    ]
  },
  variants: {
    inline: {
      true: {
        root: ["flex-row", "items-center"]
      },
      false: {
        root: ["flex-col items-start"]
      }
    },
    hasLabel: {
      true: {
        root: ""
      }
    }
  },
  compoundVariants: [
    {
      inline: !0,
      hasLabel: !0,
      class: {
        root: ["gap-2"]
      }
    },
    {
      inline: !1,
      hasLabel: !0,
      class: {
        root: ["gap-1"]
      }
    }
  ]
}), {
  root: $t,
  scrubArea: Yt,
  scrubAreaCursor: qt,
  label: Xt,
  fieldGroup: Jt,
  decrement: Zt,
  input: Qt,
  increment: en
} = zt();
function Cn(n) {
  const {
    label: e,
    helpText: t,
    required: a,
    error: o,
    id: f,
    inline: b,
    className: m,
    inputProps: g,
    onValueChange: y,
    defaultValue: i = 1,
    ...d
  } = n, { className: x, ...D } = g || {}, c = f || r.useId(), p = r.useRef(null), v = r.useCallback(
    (M, h) => {
      p.current !== M && (p.current = M, typeof y == "function" && y(M, h));
    },
    [y]
  );
  return r.useEffect(() => {
    p.current = i;
  }, [i]), /* @__PURE__ */ Z.jsxs(
    tt,
    {
      id: c,
      defaultValue: i,
      className: $t({
        hasLabel: !!e,
        inline: b,
        className: typeof m == "string" ? m : ""
      }),
      onValueChange: v,
      ...d,
      children: [
        /* @__PURE__ */ Z.jsxs(it, { className: Yt(), children: [
          e && /* @__PURE__ */ Z.jsx("label", { htmlFor: c, className: Xt(), children: e }),
          /* @__PURE__ */ Z.jsx(
            at,
            {
              className: qt(),
              children: /* @__PURE__ */ Z.jsx(Ft, {})
            }
          )
        ] }),
        /* @__PURE__ */ Z.jsxs(nt, { className: Jt(), children: [
          /* @__PURE__ */ Z.jsx(ot, { className: Zt(), children: /* @__PURE__ */ Z.jsx(At, {}) }),
          /* @__PURE__ */ Z.jsx(
            ut,
            {
              ...D,
              className: Qt({
                class: typeof x == "string" ? x : ""
              })
            }
          ),
          /* @__PURE__ */ Z.jsx(st, { className: en(), children: /* @__PURE__ */ Z.jsx(Pt, {}) })
        ] })
      ]
    }
  );
}
export {
  Cn as default
};
